import { Alert, Button } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { usePlanningStore } from '@planning/AppProvider'
import { useNavigationStore } from '@planning/stores/NavigationStack'
import { observer } from 'mobx-react-lite'

interface Props {
  onWorkAssignmentsSelection: () => void
}

export const TallymanOperationStoppedAlert = observer(({ onWorkAssignmentsSelection }: Props) => {
  const { t } = useTranslate()
  const { tallymanSelectVesselAndOperationViewStore: store } = usePlanningStore()

  const navigationStore = useNavigationStore()

  const onClick = () => {
    store.vesselTallyStore.selectCrane()
    store.vesselTallyStore.selectVesselVisit()

    navigationStore.clear()
    onWorkAssignmentsSelection()
  }

  return (
    !store.vesselTallyStore.isSelectedVisitInOperation && (
      <Alert
        severity='warning'
        action={
          <Button color='inherit' size='small' onClick={onClick}>
            {t('editVessel', 'Edit vessel.')}
          </Button>
        }
      >
        {t('operationStopped', 'Operation stopped.')}
      </Alert>
    )
  )
})
